import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ArticleEntry() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-100/60">
      <div className="container-custom max-w-4xl mx-auto text-center">
        <div className="rounded-3xl overflow-hidden mb-10 md:mb-14">
          <img
            src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20an%20open%20notebook%20with%20handwritten%20notes%20surrounded%20by%20colorful%20fabric%20swatches%20measuring%20tape%20and%20small%20fashion%20sketches%20on%20a%20warm%20wooden%20desk%2C%20morning%20sunlight%20from%20the%20left%2C%20creative%20studio%20aesthetic%2C%20editorial%20photography%2C%20no%20text%2C%20designer%20workspace%20vibe&width=1400&height=600&seq=article-entry-v2-u&orientation=landscape"
            alt="AllChinaBuy Spreadsheet buying guide"
            className="w-full h-auto object-cover"
            loading="lazy"
          />
        </div>

        <div className="space-y-1 mb-8">
          <p className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight">
            {t("home:articleEntryTitle", "Want to master the AllChinaBuy Spreadsheet?")}
          </p>
          <p className="text-xl md:text-2xl text-foreground-500 font-light">
            {t("home:articleEntryDesc", "Read our complete buying guide")}
          </p>
        </div>

        <Link
          to="/allchinabuy-spreadsheet-guide"
          className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-foreground-900 text-background-50 text-sm md:text-base font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap"
        >
          {t("home:articleEntryCTA", "Read Buying Guide →")}
        </Link>
      </div>
    </section>
  );
}